import { createSlice } from '@reduxjs/toolkit';
export type TState = {
  electric: null | boolean;
  gas: null | boolean;
};

export const initialState: TState = {
  electric: null,
  gas: null
};

export const slice = createSlice({
  name: 'fuelType',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.electric = initialState.electric;
      state.gas = initialState.gas;
    },
    setElectric: (state) => {
      state.electric = true;
      state.gas = false;
    },
    setGas: (state) => {
      state.gas = true;
      state.electric = false;
    },
    setGasElectric: (state) => {
      state.gas = true;
      state.electric = true;
    },
    setFuelType: (state, { payload }) => {
      const { gas, electric } = payload;
      state.gas = gas;
      state.electric = electric;
    }
  }
});

export const {
  setInitialState,
  setElectric,
  setGas,
  setGasElectric,
  setFuelType
} = slice.actions;

export const selectFuelType = (state) => {
  return state[slice.name];
};

export default slice.reducer;
